import _ from 'lodash'

window.addEventListener('load', function () {

    /* Back to top
    ---------------------------------------------------------------------------------------------------- */
    let scrollToTop = function (ev) {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        })
    }
    const $btnScrollTop = document.querySelectorAll('#back-to-top')

    if ($btnScrollTop.length > 0) {
        for (let bEl of $btnScrollTop) {
            bEl.addEventListener('click', scrollToTop)
        }
    }

})

document.addEventListener('hasCookieConsented', function () {})
